import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import MainRouter from './router';

import 'normalize.css';
import 'styles/index.scss';

const render = () => (
  ReactDOM.render(
    <AppContainer>
      <MainRouter />
    </AppContainer>,
    document.getElementById('root')
  )
)

render();

if (module.hot) {
  module.hot.accept()
}